import { createCanvasWithImage, getImageData } from './canvas';

export async function loadImage(url: string): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
        const image = new Image();

        image.setAttribute('crossOrigin', 'anonymous');

        image.onload = () => {
            resolve(image);
        };

        image.onerror = (e) => {
            reject(e);
        };

        image.src = url;
    });
}
export function makeImageOpaque(canvas: HTMLCanvasElement): HTMLCanvasElement {
    const ctx = canvas.getContext('2d') as CanvasRenderingContext2D;
    const imageData = getImageData(canvas);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
        data[i + 3] = 255;
    }

    ctx.putImageData(imageData, 0, 0);

    return canvas;
}

export async function rewriteImageAlpha(originImageURL: string, resultImageURL: string): Promise<HTMLCanvasElement> {
    const resultImage = await loadImage(resultImageURL);
    const originImage = await loadImage(originImageURL);

    // originImage 尺寸需要放大到 resultImageCanvas 一致
    originImage.width = resultImage.width;
    originImage.height = resultImage.height;

    const resultImageCanvas = createCanvasWithImage(resultImage);
    const originImageScaledCanvas = createCanvasWithImage(originImage);

    const resultImageData = getImageData(resultImageCanvas);
    const originImageData = getImageData(originImageScaledCanvas);

    // 使用 originImageData.data 的 alpha 通道覆盖 resultImageData.data 的 alpha 通道
    for (let i = 0; i < originImageData.data.length; i += 4) {
        resultImageData.data[i + 3] = originImageData.data[i + 3];
    }

    const ctx = resultImageCanvas.getContext('2d') as CanvasRenderingContext2D;
    ctx.putImageData(resultImageData, 0, 0);

    return resultImageCanvas;
}

// 校验是否有alpha透明通道
export async function checkIsTransparentImage(url: string) {
    if (url.indexOf('.png') === -1) return false;

    const originImage = await loadImage(url);
    const originCanvas = createCanvasWithImage(originImage);
    const hasAlpha = isTransparentImage(originCanvas);

    return hasAlpha;
}

/**
 * 判断图片是否含有透明通道
 * @param image
 * @returns
 */
export function isTransparentImage(canvas: HTMLCanvasElement) {
    const imageData = getImageData(canvas);
    const { data } = imageData;
    const length = data.length / 4;

    for (let i = 0; i < length; i += 1) {
        const alpha = data[i * 4 + 3];

        if (alpha < 255) {
            return true;
        }
    }

    return false;
}

export function imageToCanvas(image: HTMLImageElement, fillStyle?: string): HTMLCanvasElement {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d')!;

    const { width, height } = image;

    canvas.width = image.width;
    canvas.height = image.height;

    if (fillStyle) {
        ctx.fillStyle = fillStyle;
        ctx.fillRect(0, 0, width, height);
    }

    ctx.drawImage(image, 0, 0, width, height);

    return canvas;
}

export async function convertToJpgBase64(url: string): Promise<string> {
    const image = await loadImage(url);
    const isJpg = url.toLowerCase().endsWith('.jpg') || url.toLowerCase().endsWith('.jpeg');
    if (isJpg) return '';
    const canvas = imageToCanvas(image, 'white');
    return canvas.toDataURL('image/jpeg');
}

// base64 转file文件
export function base64ToFile(dataUrl: string, filename: string) {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)![1];
    const suffix = mime.split('/')[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], `${filename}.${suffix}`, { type: mime });
}

/**
 * 根据 url 获取图片的 mime type，兼容 base64 和 url
 * @param url url
 * @returns mime type image/
 */
export const getImageMimeType = (url: string): string => {
    const defaultType = 'image/png';
    if (url.startsWith('data:image/')) {
        return `image/${url.split(';')[0].split('/')[1] || defaultType}`;
    }
    return `image/${url.split('.').pop()?.toLowerCase() || defaultType}`;
};
